import {GET_OWN_INTAKE_QUERY} from '../queries/GET_OWN_INTAKE_QUERY'
import {intakeMetrics} from '../organisms/Intakes/intakeMetrics/calcIntakeMetrics'
import {ExecutionResult} from 'graphql'
import {GetOwnIntakeQuery} from '../schema/schemaTypes'
import {apolloClient} from '../utils/apolloClient'

const CheckKidsValidity = async () => {
  const { data }: ExecutionResult<GetOwnIntakeQuery> = await apolloClient.query<GetOwnIntakeQuery>({
      query: GET_OWN_INTAKE_QUERY }) as any
  if (data && data.getOwnIntake) {
    const intake = data.getOwnIntake
    const result = intakeMetrics(intake)
    return result.section4Started
  } else {
    window.location.reload()
    return false
  }
}

export default CheckKidsValidity



// WEBPACK FOOTER //
// ./src/atoms/CheckKidsValidity.ts